import { forwardRef, type Ref, type SVGProps } from "react";
const IconArrowRightCircleOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M16.2 8.3a1 1 0 0 0 0 1.5l5.3 5.2H8a1 1 0 0 0 0 2h13.5l-5.3 5.2a1 1 0 0 0 0 1.5 1 1 0 0 0 1.5 0l7-6.9a1 1 0 0 0 .3-.8 1.1 1.1 0 0 0-.3-.8l-7-6.9a1 1 0 0 0-1.5 0"
    />
    <path
      fill="currentColor"
      d="M16 28a12 12 0 1 1 0-24 12 12 0 0 1 0 24m0 2a14 14 0 1 0 0-28 14 14 0 0 0 0 28"
    />
  </svg>
);
const ForwardRef = forwardRef(IconArrowRightCircleOutlineSVG);
ForwardRef.displayName = "IconArrowRightCircleOutline";
export { ForwardRef as IconArrowRightCircleOutline };
